import { fetchCompareDetails } from '@gn-audio/core/api/compatibility-guide/fetch-compare-details';
import { fetchSolution } from '@gn-audio/core/api/compatibility-guide/fetch-solution';
import { fetchSolutionDetails } from '@gn-audio/core/api/compatibility-guide/fetch-solution-details';
import { fetchGroups } from '@gn-audio/core/api/product-catalogue/fetch-groups';
import { StaticLocationParamaters } from 'cg-foundation-theming';
export var RouteConfiguration = [
    '$routeProvider',
    function ($routeProvider) {
        var locale = document.documentElement.dataset.marketLocale;
        var isLangInPath = document.documentElement.dataset.langInPath === 'true';
        var localePrefix = isLangInPath ? "/" + locale : '';
        var templateLocale = isLangInPath ? locale + "/" : '';
        $routeProvider
            .when(localePrefix + "/compatibilityguide", {
            controller: 'devicesPageController',
            resolve: {
                init: [
                    '$q',
                    'history3Products',
                    function ($q, history3Products) {
                        var deferred = $q.defer();
                        history3Products.clear();
                        deferred.resolve();
                        return deferred.promise;
                    },
                ],
            },
            templateUrl: templateLocale + "compatibilityguide/ng-pages/project/common/devices",
        })
            .when(localePrefix + "/compatibilityguide/gallery", {
            controller: 'galleryPageController',
            resolve: {
                searchResult: [
                    '$q',
                    'routes',
                    'locationService',
                    'locationSearchQuery',
                    'history3Products',
                    function ($q, routes, locationService, locationSearchQuery, history3Products) {
                        var deferred = $q.defer();
                        locationSearchQuery.build().then(function (locationSearchResult) {
                            var thirdPartyProducts = locationService.get(StaticLocationParamaters.thirdPartyProducts, true);
                            $q.when(fetchSolution(thirdPartyProducts, locationSearchResult.query, locationSearchResult.orderBy, locationSearchResult.availableState))
                                .then(function (result) {
                                history3Products.push(thirdPartyProducts);
                                deferred.resolve(result);
                            }, function (reason) {
                                deferred.reject(reason);
                                if (Array.isArray(history3Products.getLast())) {
                                    routes.setGallery(history3Products.getLast(), reason.status);
                                }
                                else {
                                    routes.setHome(reason.status);
                                }
                            });
                        }, function () {
                            deferred.reject();
                        });
                        return deferred.promise;
                    },
                ],
            },
            templateUrl: templateLocale + "compatibilityguide/ng-pages/project/common/gallery",
        })
            .when(localePrefix + "/compatibilityguide/solutions", {
            controller: 'solutionPageController',
            reloadOnSearch: false,
            resolve: {
                cartChannelItems: [
                    '$q',
                    'locationCartState',
                    function ($q, locationCartState) {
                        var deferred = $q.defer();
                        var cartGroups = locationCartState.get();
                        var flatten = [];
                        for (var _i = 0, cartGroups_1 = cartGroups; _i < cartGroups_1.length; _i++) {
                            var cartGroup = cartGroups_1[_i];
                            flatten = flatten.concat(cartGroup.map(Number));
                        }
                        if (flatten.length === 0) {
                            deferred.resolve([]);
                            return;
                        }
                        $q.when(fetchGroups(flatten))
                            .then(function (groups) {
                            var cartChannelItems = [];
                            for (var _i = 0, cartGroups_2 = cartGroups; _i < cartGroups_2.length; _i++) {
                                var cartGroup = cartGroups_2[_i];
                                var cartChannelItem = [];
                                var _loop_1 = function (cartGroupId) {
                                    var group = groups.filter(function (x) { return x.groupId === Number(cartGroupId); })[0];
                                    if (group === undefined) {
                                        return "continue";
                                    }
                                    cartChannelItem.push({
                                        groupId: group.groupId,
                                        name: group.productName,
                                        sku: group.sku,
                                    });
                                };
                                for (var _a = 0, cartGroup_1 = cartGroup; _a < cartGroup_1.length; _a++) {
                                    var cartGroupId = cartGroup_1[_a];
                                    _loop_1(cartGroupId);
                                }
                                if (cartChannelItem.length > 0) {
                                    cartChannelItems.push(cartChannelItem);
                                }
                            }
                            deferred.resolve(cartChannelItems);
                        }, function () { deferred.reject(); });
                        return deferred.promise;
                    },
                ],
                solutionResult: [
                    '$q',
                    'routes',
                    'locationService',
                    'history3Products',
                    'locationSearchQuery',
                    function ($q, routes, locationService, history3Products, locationSearchQuery) {
                        var thirdPartyProducts = locationService.get(StaticLocationParamaters.thirdPartyProducts, true);
                        var products = locationService.get(StaticLocationParamaters.products, true);
                        var product = products[0];
                        var deferred = $q.defer();
                        locationSearchQuery.build().then(function (locationSearchResult) {
                            $q.when(fetchSolutionDetails(thirdPartyProducts, product, locationSearchResult.availableState))
                                .then(function (result) {
                                history3Products.push(thirdPartyProducts);
                                deferred.resolve(result);
                            }, function (reason) {
                                var responseData = reason.data;
                                var dataInResponse = Boolean(responseData);
                                var status = reason.status;
                                status = status === 404 && dataInResponse && responseData.group === null ? 4041 : status;
                                deferred.reject();
                                routes.setGallery(thirdPartyProducts, status);
                            });
                        });
                        return deferred.promise;
                    },
                ],
            },
            templateUrl: templateLocale + "compatibilityguide/ng-pages/project/common/solutions",
        })
            .when(localePrefix + "/compatibilityguide/compare", {
            controller: 'comparePageController',
            resolve: {
                compareResult: [
                    '$q',
                    'locationService',
                    'routes',
                    'locationSearchQuery',
                    function ($q, locationService, routes, locationSearchQuery) {
                        var deferred = $q.defer();
                        var thirdPartyProducts = locationService.get(StaticLocationParamaters.thirdPartyProducts, true);
                        var products = locationService.get(StaticLocationParamaters.products, true);
                        locationSearchQuery.build().then(function (locationSearchResult) {
                            $q.when(fetchCompareDetails(thirdPartyProducts, products, locationSearchResult.availableState))
                                .then(function (result) {
                                deferred.resolve(result);
                            }, function (reason) {
                                var responseData = reason.data;
                                var dataInResponse = Boolean(responseData);
                                var status = reason.status;
                                status = status === 404 && dataInResponse && responseData.products === null ? 4041 : status;
                                deferred.reject();
                                routes.setGallery(thirdPartyProducts, status);
                            });
                        });
                        return deferred.promise;
                    },
                ],
            },
            templateUrl: templateLocale + "compatibilityguide/ng-pages/project/common/compare",
        })
            .otherwise({
            redirectTo: localePrefix + "/compatibilityguide",
        });
    },
];
